import { createAttributeComponent } from "@coltorapps/builder-react";
import CodeEditButton, {
  DEFAULT_TRIGGER_TEXT,
} from "@ui/button/code-edit-button";
import { ValidationError, formatError } from "@ui/validation-error";
import { DEFAULT_EXPRESSION_TEMPLATE } from "@/const/expression";
import { expressionAttribute } from "./definition";

export const ExpressionAttribute = createAttributeComponent(
  expressionAttribute,
  function ExpressionAttribute(props) {
    const formattedError = formatError(
      props.attribute.value,
      props.attribute.error,
    );
    const fieldError =
      formattedError?._errors?.[0] ??
      (props.attribute.error instanceof Error
        ? props.attribute.error.message
        : undefined);

    return (
      <div className="flex flex-col gap-1.5">
        <div className="text-dark text-base font-medium">Expression</div>
        <CodeEditButton
          variant="reference"
          title="Expression"
          value={props.attribute.value || DEFAULT_EXPRESSION_TEMPLATE}
          trigger={
            props.attribute.value?.trim()
              ? props.attribute.value.trim()
              : DEFAULT_TRIGGER_TEXT
          }
          onSave={(value) => {
            props.setValue(value || "");
          }}
        />

        <ValidationError>{fieldError}</ValidationError>
      </div>
    );
  },
);
